export default {
  goalUsers: (state) => {
    return state.goalUsers;
  },

  goalSchedules: (state) => {
    return state.goalSchedules;
  },

  goals: (state) => {
    return state.goals;
  },
  goal: (state) => {
    return state.goal;
  },
  goalDetail: (state) => {
    return state.goalDetail;
  },
  goalId: (state) => {
    return state.goalId;
  },
  goalCode: (state) => {
    return state.goalCode;
  },

  taskCategorys: (state) => {
    return state.taskCategorys;
  },
  taskCategory: (state) => {
    return state.taskCategory;
  },
  taskCategoryCode: (state) => {
    return state.taskCategoryCode;
  },

  noteCategorys: (state) => {
    return state.noteCategorys;
  },
  noteCategory: (state) => {
    return state.noteCategory;
  },
  noteCategoryCode: (state) => {
    return state.noteCategoryCode;
  },

  projectTypes: (state) => {
    return state.projectTypes;
  },

  projectType: (state) => {
    return state.projectType;
  },

  projectTypeCode: (state) => {
    return state.projectTypeCode;
  },

  workDescriptions: (state) => {
    return state.workDescriptions;
  },

  workDescription: (state) => {
    return state.workDescription;
  },

  workDescriptionCode: (state) => {
    return state.workDescriptionCode;
  },

  noteSubjects: (state) => {
    return state.noteSubjects;
  },
  noteSubject: (state) => {
    return state.noteSubject;
  },
  noteSubjectCode: (state) => {
    return state.noteSubjectCode;
  },

  requestTypes: (state) => {
    return state.requestTypes;
  },
  requestType: (state) => {
    return state.requestType;
  },
  requestTypeCode: (state) => {
    return state.requestTypeCode;
  },

  callSubjects: (state) => {
    return state.callSubjects;
  },
  callSubject: (state) => {
    return state.callSubject;
  },
  callSubjectCode: (state) => {
    return state.callSubjectCode;
  },

  callCategories: (state) => {
    return state.callCategories;
  },
  callCategory: (state) => {
    return state.callCategory;
  },
  callCategoryCode: (state) => {
    return state.callCategoryCode;
  },

  serviceSupportSubjects: (state) => {
    return state.serviceSupportSubjects;
  },
  serviceSupportSubject: (state) => {
    return state.serviceSupportSubject;
  },
  serviceSupportSubjectCode: (state) => {
    return state.serviceSupportSubjectCode;
  },
  serviceSupports: (state) => {
    return state.serviceSupports;
  },
  serviceSupport: (state) => {
    return state.serviceSupport;
  },
  serviceSupportCode: (state) => {
    return state.serviceSupportCode;
  },
  contracts: (state) => {
    return state.contracts;
  },
  contract: (state) => {
    return state.contract;
  },
  contractCode: (state) => {
    return state.contractCode;
  },
  setting: (state) => {
    return state.setting;
  },

  tasks: (state) => {
    return state.tasks;
  },
  taskTimers: (state) => state.taskTimers,
  task: (state) => {
    return state.task;
  },
  taskId: (state) => {
    return state.taskId;
  },
  taskCode: (state) => {
    return state.taskCode;
  },
  taskNavigation: (state) => {
    return state.taskNavigation;
  },

  taskTeams: (state) => {
    return state.taskTeams;
  },
  taskTeam: (state) => {
    return state.taskTeam;
  },

  messages: (state) => {
    return state.messages;
  },
  message: (state) => {
    return state.message;
  },
  messageCode: (state) => {
    return state.messageCode;
  },

  calls: (state) => {
    return state.calls;
  },
  call: (state) => {
    return state.call;
  },
  callCode: (state) => {
    return state.callCode;
  },

  requests: (state) => {
    return state.requests;
  },
  request: (state) => {
    return state.request;
  },
  requestCode: (state) => {
    return state.requestCode;
  },

  notes: (state) => {
    return state.notes;
  },
  note: (state) => {
    return state.note;
  },
  noteCode: (state) => {
    return state.noteCode;
  },

  meetings: (state) => {
    return state.meetings;
  },
  meeting: (state) => {
    return state.meeting;
  },
  meetingId: (state) => {
    return state.meetingId;
  },

  meetingCode: (state) => {
    return state.meetingCode;
  },

  projects: (state) => {
    return state.projects;
  },
  project: (state) => {
    return state.project;
  },
  projectId: (state) => {
    return state.projectId;
  },
  projectCode: (state) => {
    return state.projectCode;
  },

  projectTeams: (state) => {
    return state.projectTeams;
  },
  projectTeam: (state) => {
    return state.projectTeam;
  },

  reminders: (state) => {
    return state.reminders;
  },
};
